export const CONSTANTS = {
  GOOGLE_JS_MAPS_KEY: 'AIzaSyBpQrcOKExBddu3egalhtbosdmSXUMHrGU',
  GOOGLE_STATIC_MAPS_KEY: 'AIzaSyAbh1HTCIX74NuOWXHT7l1oUyYrjTBTiFY',
  GOOGLE_MAP_THEME_STYLES: [
    {
      elementType: "geometry",
      stylers: [
        {
          color: "#1d2c4d",
        },
      ],
    },
    {
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#8ec3b9",
        },
      ],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [
        {
          color: "#1a3646",
        },
      ],
    },
    {
      featureType: "administrative.country",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#4b6878",
        },
      ],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#64779e",
        },
      ],
    },
    {
      featureType: "administrative.province",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#4b6878",
        },
      ],
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#334e87",
        },
      ],
    },
    {
      featureType: "landscape.natural",
      elementType: "geometry",
      stylers: [
        {
          color: "#023e58",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#283d6a",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.text",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#6f9ba5",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.text.stroke",
      stylers: [
        {
          color: "#1d2c4d",
        },
      ],
    },
    {
      featureType: "poi.business",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#023e58",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#3C7680",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [
        {
          color: "#304a7d",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#98a5be",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels.text.stroke",
      stylers: [
        {
          color: "#1d2c4d",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [
        {
          color: "#2c6675",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#255763",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#b0d5ce",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.stroke",
      stylers: [
        {
          color: "#023e58",
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "transit",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#98a5be",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "labels.text.stroke",
      stylers: [
        {
          color: "#1d2c4d",
        },
      ],
    },
    {
      featureType: "transit.line",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#283d6a",
        },
      ],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [
        {
          color: "#3a4762",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#0e1626",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#4e6d70",
        },
      ],
    },
  ],

  GOOGLE_MAP_THEME_STYLES_ALLS: [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#212121"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#212121"
        }
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "administrative.country",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.locality",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#181818"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1b1b1b"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#2c2c2c"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#8a8a8a"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#373737"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#3c3c3c"
        }
      ]
    },
    {
      "featureType": "road.highway.controlled_access",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#4e4e4e"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#000000"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#3d3d3d"
        }
      ]
    }
  ],


  GOOGLE_MAP_THEME_STYLES_ALL: [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#8ec3b9"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1a3646"
        }
      ]
    },
    {
      "featureType": "administrative.country",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#4b6878"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#64779e"
        }
      ]
    },
    {
      "featureType": "administrative.province",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#4b6878"
        }
      ]
    },
    {
      "featureType": "landscape.man_made",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#334e87"
        }
      ]
    },
    {
      "featureType": "landscape.natural",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#283d6a"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.icon",
      "stylers": [
        {
          "saturation": -40
        },
        {
          "lightness": -30
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#6f9ba5"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#3C7680"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#304a7d"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "saturation": -25
        },
        {
          "lightness": -20
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#98a5be"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#2c6675"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#255763"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#b0d5ce"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#98a5be"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#283d6a"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#3a4762"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#0e1626"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#4e6d70"
        }
      ]
    }
  ],
  GOOGLE_MAP_THEME_STYLES_POI: [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#8ec3b9"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1a3646"
        }
      ]
    },
    {
      "featureType": "administrative.country",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#4b6878"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#64779e"
        }
      ]
    },
    {
      "featureType": "administrative.province",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#4b6878"
        }
      ]
    },
    {
      "featureType": "landscape.man_made",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#334e87"
        }
      ]
    },
    {
      "featureType": "landscape.natural",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#283d6a"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.icon",
      "stylers": [
        {
          "saturation": -40
        },
        {
          "lightness": -30
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#6f9ba5"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#3C7680"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#304a7d"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "saturation": -25
        },
        {
          "lightness": -20
        },
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#98a5be"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#2c6675"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#255763"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#b0d5ce"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#98a5be"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#283d6a"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#3a4762"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#0e1626"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#4e6d70"
        }
      ]
    }
  ],
  GOOGLE_MAP_THEME_STYLES_ROAD: [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#8ec3b9"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1a3646"
        }
      ]
    },
    {
      "featureType": "administrative.country",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#4b6878"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#64779e"
        }
      ]
    },
    {
      "featureType": "administrative.province",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#4b6878"
        }
      ]
    },
    {
      "featureType": "landscape.man_made",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#334e87"
        }
      ]
    },
    {
      "featureType": "landscape.natural",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#283d6a"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.icon",
      "stylers": [
        {
          "saturation": -40
        },
        {
          "lightness": -30
        },
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#6f9ba5"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#3C7680"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#304a7d"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "saturation": -25
        },
        {
          "lightness": -20
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#98a5be"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#2c6675"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#255763"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#b0d5ce"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#98a5be"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#283d6a"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#3a4762"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#0e1626"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#4e6d70"
        }
      ]
    }
  ],
  GOOGLE_MAP_THEME_STYLES_BASIC: [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#8ec3b9"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1a3646"
        }
      ]
    },
    {
      "featureType": "administrative.country",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#4b6878"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#64779e"
        }
      ]
    },
    {
      "featureType": "administrative.province",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#4b6878"
        }
      ]
    },
    {
      "featureType": "landscape.man_made",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#334e87"
        }
      ]
    },
    {
      "featureType": "landscape.natural",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#283d6a"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.icon",
      "stylers": [
        {
          "saturation": -40
        },
        {
          "lightness": -30
        },
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#6f9ba5"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#3C7680"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#304a7d"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "saturation": -25
        },
        {
          "lightness": -20
        },
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#98a5be"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#2c6675"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#255763"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#b0d5ce"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#023e58"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#98a5be"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#1d2c4d"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#283d6a"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#3a4762"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#0e1626"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#4e6d70"
        }
      ]
    }
  ]
};

export const COLOR_GRAY = '#979797'
export const COLOR_GREEN = '#27A647'
export const COLOR_RED = '#FF3B45'
export const VehicleBrands = [
  { code: "Acura", name: "Acura" },
  { code: "Alfa Romeo", name: "Alfa Romeo" },
  { code: "Ashok Leyland", name: "Ashok Leyland" },
  { code: "Aston Martin", name: "Aston Martin" },
  { code: "Audi", name: "Audi" },
  { code: "Bentley", name: "Bentley" },
  { code: "BMW", name: "BMW" },
  { code: "Buick", name: "Buick" },
  { code: "Cadillac", name: "Cadillac" },
  { code: "Changan", name: "Changan" },
  { code: "Chevrolet", name: "Chevrolet" },
  { code: "Chrysler", name: "Chrysler" },
  { code: "Daewoo", name: "Daewoo" },
  { code: "Dodge", name: "Dodge" },
  { code: "Ferrari", name: "Ferrari" },
  { code: "FIAT", name: "FIAT" },
  { code: "Ford", name: "Ford" },
  { code: "FOTON", name: "FOTON" },
  { code: "GAC", name: "GAC" },
  { code: "GMC", name: "GMC" },
  { code: "Great Wall Motors", name: "Great Wall Motors" },
  { code: "Hino", name: "Hino" },
  { code: "Honda", name: "Honda" },
  { code: "Hyundai", name: "Hyundai" },
  { code: "Infiniti", name: "Infiniti" },
  { code: "Isuzu", name: "Isuzu" },
  { code: "IVECO", name: "IVECO" },
  { code: "JAC Motors", name: "JAC Motors" },
  { code: "Jaguar", name: "Jaguar" },
  { code: "Jeep", name: "Jeep" },
  { code: "JMC", name: "JMC" },
  { code: "Kia", name: "Kia" },
  { code: "Lamborghini", name: "Lamborghini" },
  { code: "Land Rover", name: "Land Rover" },
  { code: "Lexus", name: "Lexus" },
  { code: "Lincoln", name: "Lincoln" },
  { code: "Man", name: "Man" },
  { code: "Maserati", name: "Maserati" },
  { code: "Mazda", name: "Mazda" },
  { code: "McLaren", name: "McLaren" },
  { code: "Mercedes-Benz", name: "Mercedes-Benz" },
  { code: "MG", name: "MG" },
  { code: "MINI", name: "MINI" },
  { code: "Mitsubishi", name: "Mitsubishi" },
  { code: "Nissan", name: "Nissan" },
  { code: "Peugeut", name: "Peugeut" },
  { code: "Porsche", name: "Porsche" },
  { code: "RAM", name: "RAM" },
  { code: "Renault", name: "Renault" },
  { code: "Rolls-Royce", name: "Rolls-Royce" },
  { code: "Scania", name: "Scania" },
  { code: "Scion", name: "Scion" },
  { code: "smart", name: "smart" },
  { code: "Subaru", name: "Subaru" },
  { code: "Suzuki", name: "Suzuki" },
  { code: "Tata", name: "Tata" },
  { code: "Tesla", name: "Tesla" },
  { code: "Toyota", name: "Toyota" },
  { code: "Volkswagen", name: "Volkswagen" },
  { code: "Volvo", name: "Volvo" },
  { code: "Western Star", name: "Western Star" },
];

export const ZoneData = [
  { location: "RSA", coordinates: { lat: 24.951141, lng: 55.150944 }, zone: '' },
  {
    location: "VSA1",
    coordinates: { lat: 24.967693, lng: 55.148743 },
    zone: "Red Zone",
    route: [
      [
        55.14942739867963,
        24.95252107318593
      ],
      [
        55.1497855079414,
        24.95322348053988
      ],
      [
        55.15007061934184,
        24.953643217933
      ],
      [
        55.15023139921106,
        24.95392262368532
      ],
      [
        55.1503043619881,
        24.95410767236674
      ],
      [
        55.15039711551386,
        24.95432043868173
      ],
      [
        55.15049964768821,
        24.95445952653193
      ],
      [
        55.15061745766341,
        24.95453813088803
      ],
      [
        55.15095211413686,
        24.95457812489483
      ],
      [
        55.15312731715003,
        24.95478199497128
      ],
      [
        55.15340584248139,
        24.95474353866355
      ],
      [
        55.15356729999849,
        24.95466158843854
      ],
      [
        55.15375580485068,
        24.95463567412924
      ],
      [
        55.15390302787554,
        24.95474920432081
      ],
      [
        55.15404498018881,
        24.9548380837455
      ],
      [
        55.15425037305057,
        24.95486252515215
      ],
      [
        55.1543308698938,
        24.95488209860419
      ],
      [
        55.15452028404888,
        24.95491002917296
      ],
      [
        55.1551782373255,
        24.95508890112523
      ],
      [
        55.15556715595184,
        24.95535732471114
      ],
      [
        55.15571971724174,
        24.95552155889664
      ],
      [
        55.15603036614638,
        24.95594161059248
      ],
      [
        55.15681601653829,
        24.95711506901713
      ],
      [
        55.15788045144416,
        24.95871339292058
      ],
      [
        55.15851424640756,
        24.95969421753905
      ],
      [
        55.15860442919699,
        24.95990648946545
      ],
      [
        55.15862674293893,
        24.96006515894072
      ],
      [
        55.15865242172413,
        24.96027167610554
      ],
      [
        55.15864649220277,
        24.96051929674256
      ],
      [
        55.15856929353497,
        24.96077752725846
      ],
      [
        55.15839840685083,
        24.96124893144687
      ],
      [
        55.15845999659246,
        24.96154268616515
      ],
      [
        55.15843156888575,
        24.96166659622069
      ],
      [
        55.15825866090264,
        24.96185509304953
      ],
      [
        55.15814804180927,
        24.96193320680239
      ],
      [
        55.15803083970489,
        24.96205452933798
      ],
      [
        55.15792501365994,
        24.96235422569871
      ],
      [
        55.15681384815517,
        24.96486631660191
      ],
      [
        55.15679678681745,
        24.96493909859784
      ],
      [
        55.15643331284156,
        24.96586619633559
      ],
      [
        55.15606582542742,
        24.96660543237147
      ],
      [
        55.15583958402708,
        24.96680810794759
      ],
      [
        55.15543561550702,
        24.96711256704368
      ],
      [
        55.1549884450999,
        24.96729142021144
      ],
      [
        55.1509643963054,
        24.96858420683348
      ],
      [
        55.14903830074068,
        24.96920361674752
      ],
      [
        55.14896283966997,
        24.96932370090492
      ],
      [
        55.14878821753742,
        24.96945593464277
      ],
      [
        55.14852184677007,
        24.96945634882575
      ],
      [
        55.14839642573271,
        24.969348944916
      ],
      [
        55.14841854833526,
        24.9692005063755
      ],
      [
        55.14853824446977,
        24.96903650795446
      ],
      [
        55.14858877189837,
        24.96873505108525
      ],
      [
        55.14869555049637,
        24.96693733384549
      ]
    ]
  },
  {
    location: "VSA3",
    coordinates: { lat: 24.964746, lng: 55.156175 },
    zone: "Green Zone",
    route: [
      [
        55.14942739867963,
        24.95252107318593
      ],
      [
        55.1497855079414,
        24.95322348053988
      ],
      [
        55.15007061934184,
        24.953643217933
      ],
      [
        55.15023139921106,
        24.95392262368532
      ],
      [
        55.1503043619881,
        24.95410767236674
      ],
      [
        55.15039711551386,
        24.95432043868173
      ],
      [
        55.15049964768821,
        24.95445952653193
      ],
      [
        55.15061745766341,
        24.95453813088803
      ],
      [
        55.15095211413686,
        24.95457812489483
      ],
      [
        55.15312731715003,
        24.95478199497128
      ],
      [
        55.15340584248139,
        24.95474353866355
      ],
      [
        55.15356729999849,
        24.95466158843854
      ],
      [
        55.15375580485068,
        24.95463567412924
      ],
      [
        55.15390302787554,
        24.95474920432081
      ],
      [
        55.15404498018881,
        24.9548380837455
      ],
      [
        55.15425037305057,
        24.95486252515215
      ],
      [
        55.1543308698938,
        24.95488209860419
      ],
      [
        55.15452028404888,
        24.95491002917296
      ],
      [
        55.1551782373255,
        24.95508890112523
      ],
      [
        55.15556715595184,
        24.95535732471114
      ],
      [
        55.15571971724174,
        24.95552155889664
      ],
      [
        55.15603036614638,
        24.95594161059248
      ],
      [
        55.15681601653829,
        24.95711506901713
      ],
      [
        55.15788045144416,
        24.95871339292058
      ],
      [
        55.15851424640756,
        24.95969421753905
      ],
      [
        55.15860442919699,
        24.95990648946545
      ],
      [
        55.15862674293893,
        24.96006515894072
      ],
      [
        55.15865242172413,
        24.96027167610554
      ],
      [
        55.15864649220277,
        24.96051929674256
      ],
      [
        55.15856929353497,
        24.96077752725846
      ],
      [
        55.15839840685083,
        24.96124893144687
      ],
      [
        55.15845999659246,
        24.96154268616515
      ],
      [
        55.15843156888575,
        24.96166659622069
      ],
      [
        55.15825866090264,
        24.96185509304953
      ],
      [
        55.15814804180927,
        24.96193320680239
      ],
      [
        55.15803083970489,
        24.96205452933798
      ],
      [
        55.15792501365994,
        24.96235422569871
      ],
      [
        55.15681384815517,
        24.96486631660191
      ],
      [
        55.15647615835637,
        24.96475702869228
      ],
      [
        55.15617772118615,
        24.96467627632768
      ]
    ]
  },
  {
    location: "VSA4",
    coordinates: { lat: 24.959309, lng: 55.143478 },
    zone: "Blue Zone",
    route: [
      [
        55.14942739867963,
        24.95252107318593
      ],
      [
        55.1497855079414,
        24.95322348053988
      ],
      [
        55.15007061934184,
        24.953643217933
      ],
      [
        55.15023139921106,
        24.95392262368532
      ],
      [
        55.1503043619881,
        24.95410767236674
      ],
      [
        55.15039711551386,
        24.95432043868173
      ],
      [
        55.15049964768821,
        24.95445952653193
      ],
      [
        55.15061745766341,
        24.95453813088803
      ],
      [
        55.15095211413686,
        24.95457812489483
      ],
      [
        55.15312731715003,
        24.95478199497128
      ],
      [
        55.15340584248139,
        24.95474353866355
      ],
      [
        55.15356729999849,
        24.95466158843854
      ],
      [
        55.15375580485068,
        24.95463567412924
      ],
      [
        55.15390302787554,
        24.95474920432081
      ],
      [
        55.1539770140161,
        24.95488229438484
      ],
      [
        55.15396762784546,
        24.95503466104791
      ],
      [
        55.15382958341431,
        24.95509745648914
      ],
      [
        55.15359565042815,
        24.95515631644709
      ],
      [
        55.15341647346089,
        24.95497529274618
      ],
      [
        55.15312984192508,
        24.95487598007687
      ],
      [
        55.15129710926256,
        24.95475043055301
      ],
      [
        55.15042684440795,
        24.95464665907876
      ],
      [
        55.14971933332644,
        24.9545881440765
      ],
      [
        55.1488387018075,
        24.95482866658022
      ],
      [
        55.14595648713029,
        24.95589620194921
      ],
      [
        55.1455813143356,
        24.95623988330475
      ],
      [
        55.14535349973252,
        24.9564376216287
      ],
      [
        55.14504670077029,
        24.95673551006047
      ],
      [
        55.14436438899119,
        24.95722216535323
      ],
      [
        55.14372675087656,
        24.95772390083226
      ],
      [
        55.14361621725976,
        24.95798824314052
      ],
      [
        55.14361171176579,
        24.95818325740838
      ],
      [
        55.14358730554138,
        24.95849522906259
      ],
      [
        55.14356885417055,
        24.95873106027796
      ],
      [
        55.14370296271969,
        24.95901864725417
      ],
      [
        55.14382373452911,
        24.95925712794756
      ],
      [
        55.14403249614786,
        24.95962655260265
      ],
      [
        55.14416713613288,
        24.95982678061926
      ],
      [
        55.14431933641894,
        24.96005312486423
      ]
    ]
  },
  {
    location: "VSA Gold ",
    coordinates: { lat: 24.956407, lng: 55.152742 },
    zone: "Gold Zone",
    route: [
      [
        55.14942739867963,
        24.95252107318593
      ],
      [
        55.1497855079414,
        24.95322348053988
      ],
      [
        55.15007061934184,
        24.953643217933
      ],
      [
        55.15023139921106,
        24.95392262368532
      ],
      [
        55.1503043619881,
        24.95410767236674
      ],
      [
        55.15039711551386,
        24.95432043868173
      ],
      [
        55.15049964768821,
        24.95445952653193
      ],
      [
        55.15061745766341,
        24.95453813088803
      ],
      [
        55.15095211413686,
        24.95457812489483
      ],
      [
        55.15312731715003,
        24.95478199497128
      ],
      [
        55.15340584248139,
        24.95474353866355
      ],
      [
        55.15356729999849,
        24.95466158843854
      ],
      [
        55.15375580485068,
        24.95463567412924
      ],
      [
        55.15390302787554,
        24.95474920432081
      ],
      [
        55.15392709560331,
        24.95477095747259
      ],
      [
        55.15395415220429,
        24.95487822522186
      ],
      [
        55.1539326405454,
        24.95496021484286
      ],
      [
        55.15387393134802,
        24.95505589988859
      ],
      [
        55.15378313927671,
        24.95510697692317
      ],
      [
        55.1537133758689,
        24.95518747210824
      ],
      [
        55.1536925148695,
        24.95527105417945
      ],
      [
        55.15367475376208,
        24.9553897942693
      ],
      [
        55.15368374022353,
        24.95551276153386
      ],
      [
        55.15368665799211,
        24.95561764684776
      ],
      [
        55.15368595776356,
        24.95573100536188
      ],
      [
        55.15368197021573,
        24.95583489192888
      ],
      [
        55.15369385688436,
        24.95597004211697
      ],
      [
        55.15369325334128,
        24.95605515993766
      ],
      [
        55.15368787329335,
        24.95614512171858
      ],
      [
        55.15367401490338,
        24.95621328652224
      ],
      [
        55.15363381605928,
        24.9562761880647
      ],
      [
        55.15357675808206,
        24.95633781328134
      ],
      [
        55.15352798340638,
        24.95642390062208
      ],
      [
        55.15349457954045,
        24.95648537520198
      ],
      [
        55.15346582464355,
        24.95651909315922
      ],
      [
        55.15347727825778,
        24.95657927195628
      ],
      [
        55.153477882947,
        24.95662418751448
      ],
      [
        55.15346300831474,
        24.9566645837372
      ],
      [
        55.15343611858056,
        24.95669489273731
      ],
      [
        55.15339044243823,
        24.95671609846394
      ],
      [
        55.15333920998037,
        24.95672886930702
      ],
      [
        55.15328446799764,
        24.95674282701141
      ],
      [
        55.15324353532576,
        24.95676894363478
      ],
      [
        55.15319800283188,
        24.95681668609575
      ],
      [
        55.153166741091,
        24.95685125782232
      ],
      [
        55.15313611996459,
        24.95689048952895
      ],
      [
        55.15311954256591,
        24.95691787416717
      ],
      [
        55.15311127029926,
        24.95695344887141
      ],
      [
        55.15312239074758,
        24.95699153526818
      ],
      [
        55.15313412058109,
        24.95704808345504
      ],
      [
        55.15311149098543,
        24.95709054914153
      ],
      [
        55.15307634108824,
        24.95711101161433
      ],
      [
        55.15303009638379,
        24.95712109616323
      ],
      [
        55.15297279510128,
        24.95711192843613
      ],
      [
        55.15293901563457,
        24.95708731382582
      ],
      [
        55.15291553874926,
        24.95705760421943
      ],
      [
        55.15290772301437,
        24.9570140995619
      ],
      [
        55.15290778794466,
        24.95697277484363
      ],
      [
        55.15290477752826,
        24.95694304201139
      ],
      [
        55.15289328965936,
        24.95690267494943
      ],
      [
        55.15287634550954,
        24.95683513781645
      ],
      [
        55.15285785196053,
        24.95677824614276
      ],
      [
        55.15285311396023,
        24.95672334688275
      ],
      [
        55.15283807421013,
        24.95664876239438
      ],
      [
        55.15282279534846,
        24.9565696847288
      ],
      [
        55.15282087874534,
        24.95651918613339
      ],
      [
        55.15281463841297,
        24.95647797879832
      ],
      [
        55.15278997154312,
        24.95645095875632
      ],
      [
        55.15272906873452,
        24.95639300996925
      ],
      [
        55.15263897044685,
        24.95635249532864
      ]
    ]
  },
];


